<template>
    <div class="container fixed-bottom">
        <div class="row">
            <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 bg-black text-white py-3 px-4">
                <div class="row">
                    <div class="col-12 col-md-9 small-text">
                        <div class="row">
                            <div class="col-12 mb-3">
                                Ali se strinjate z namestitvijo funkcionalnih in analitičnih piškotkov Google Analytics z
                                namenom spremljanja obiska spletnega mesta?
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10 small-text">
                                <a href="https://www.varninainternetu.si/izjava-o-zasebnosti-spletna-higiena/"
                                   title="Urejanje piškotkov"
                                   class="text-white" aria-label="Preberi izjavo zasebnosti">
                                    Urejanje piškotkov
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-3 mt-4 mt-md-0">
                        <div class="row">
                            <div class="col-5 col-md-12 mb-md-3">
                                <a href="#" @click.prevent="acceptCookies(true)" aria-label="Sprejmi piškotke"
                                   class="btn btn-black cookies-btn py-3 py-md-2">
                                    Strinjam se
                                </a>
                            </div>

                            <div class="col-5 col-md-12">
                                <a href="#" @click.prevent="acceptCookies(false)" aria-label="Sprejmi piškotke"
                                   class="btn btn-black cookies-btn py-3 py-md-2">
                                    Ne strinjam se
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "Cookies",
		methods: {
			acceptCookies(state) {
				this.$emit('closeCookieNotice');
				if (state === true) {
					this.$cookie.set('cookies', 'accepted', 365);
				} else {
					this.$cookie.set('cookies', 'denied', 365);
                }
			}
		},
	}
</script>

<style lang="scss" scoped>
    .cookies-btn {
        width: 100%;
        height: 100%;
        display: flex !important;
        align-items: center;
        justify-content: center;
        font-size: .8rem !important;
        text-decoration: underline !important;
    }

    .bg-black {
        background: #000;
    }

    .small-text {
        font-size: .8rem;
    }
</style>